import React, { useEffect } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import * as ReactPixel from 'meta-pixel';
const PIXEL_ID = '26257470350562748';
function Root() {
  useEffect(() => {
    try {
      const pixel: any = (ReactPixel as any).default ?? ReactPixel;
      if (pixel && typeof pixel.init === 'function') {
        pixel.init(PIXEL_ID);
        if (typeof pixel.pageView === 'function') {
          pixel.pageView();
        }
      }
    } catch (e) {
      // pixel init failed silently
    }
  }, []);
  return <App data-id="element-173" />;
}
render(<Root data-id="element-174" />, document.getElementById('root'));